var path = 'areas/environments/machinepolicies/views/create.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/environments/machinepolicies/new\">Create new</a></li> </script> <loading-wrapper busy=isLoading> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <machine-policy-editor></machine-policy-editor> </div> </div> </div> </div> </loading-wrapper>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machinepolicies/views/create.html
// module id = 767
// module chunks = 1